import { createContext, useContext } from 'react';
export const RadioGroupContext = createContext(null);
export const useRadioGroupContext = () => {
    const ctx = useContext(RadioGroupContext);
    if (!ctx) {
        throw new Error('RadioButton component must be used within a RadioGroup component.');
    }
    return ctx;
};
//# sourceMappingURL=radio-group-context.component.js.map